import { NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { GoogleAuthComponent } from './google-auth/google-auth.component';
import { LogoutComponent } from './logout/logout.component';
import { RemindPasswordComponent } from './remind-password/remind-password.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NavbarModule } from '@/common/navbar/navbar.module';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
	{
		path: 'login',
		component: LoginComponent,
	},
	{
		path: 'logout',
		component: LogoutComponent,
	},
];

@NgModule({
	declarations: [LoginComponent, GoogleAuthComponent, LogoutComponent, RemindPasswordComponent],
	imports: [RouterModule.forChild(routes), CommonModule, FormsModule, NavbarModule],
	providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class AuthModule {}
